import { render } from "./SpHome.vue?vue&type=template&id=a42f888a&scoped=true"
import script from "./SpHome.vue?vue&type=script&lang=js"
export * from "./SpHome.vue?vue&type=script&lang=js"

import "./SpHome.vue?vue&type=style&index=0&id=a42f888a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a42f888a"]])

export default __exports__